:host {
  button {
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    text-align: left;
    position: relative;
    color: $ui-blue;
    width: 100%;
    border: 1px solid $ui-blue;
    border-radius: 50px;
    padding: 5px;
    cursor: pointer;
    padding-left: 16px;

    &:hover {
      background-color: rgba($ui-blue-minus-1, 0.05);
      color: $ui-blue-minus-1;
      border-color: $ui-blue-minus-1;
    }

    &.active {
      background-color: $ui-blue;
      color: $ui-white;

      --component-icon-color: #{$ui-white};
    }
  }

  ui-icon {
    position: absolute;
    right: 8px;
    top: 1px;
    max-height: 24px;
  }
}
